export default "<p>multi-select works!</p>\r\n"